import Script from 'next/script';

export const OneTrustScripts = () => {
  // eslint-disable-next-line @opendoor/no-direct-env-check -- this compile-time switch avoids adding shared globals to every page bundle.
  const deployEnv = process.env.NEXT_PUBLIC_DEPLOY_ENV || 'development';

  if (process.env.COOKIE_BANNER_DISABLED === 'true' || deployEnv === 'test') {
    return null;
  }

  const isProduction = deployEnv === 'production';
  const domainScript = isProduction
    ? '019756e6-db1e-7dfa-97f3-4cf089c9f913'
    : '019756e6-db1e-7dfa-97f3-4cf089c9f913-test';

  return (
    <>
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        strategy="lazyOnload"
        data-domain-script={domainScript}
      />
      <Script id="optanon-wrapper" strategy="lazyOnload">
        {`function OptanonWrapper() { }`}
      </Script>
    </>
  );
};
